import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Swal from "sweetalert2";
import Select from "react-select";
import PoServices from "../../../services/PoServices";
import Spinner from 'react-bootstrap/Spinner';
import ReceivedOrderModal from './ReceivedOrderModal';
import BillingViewModal from './BillingViewModal';
import * as XLSX from "xlsx";
import PoRevisionPrintModal from "./PoRevisionPrintModal";
import Loader from "../Loader/loader";
import Pagination from "../Pagenation/Pagenation";


const RecivedOrderPO = () => {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(true);
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [gridInsideModal, setGridInsideModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [sort, setSort] = useState(100);
  const [searchTerm, setSearchTerm] = useState("");
  const [gridInsideModal2, setGridInsideModal2] = useState(false);
  const [selectedItem2, setSelectedItem2] = useState(null);
  const [gridInsideModal3, setGridInsideModal3] = useState(false);
  const [selectedItem3, setSelectedItem3] = useState(null);
  const [activePage, setActivePage] = useState(0);
  const [test, setTest] = useState(0);
  const [loading, setLoading] = useState(true);
  const [printLoadingId, setPrintLoadingId] = useState("");
  const [revisionSortOrder, setRevisionSortOrder] =
    useState(null); // null | asc | desc




  const options = [
    { value: 5, label: '5' },
    { value: 10, label: '10' },
    { value: 20, label: '20' },
    { value: 50, label: '50' },
    { value: 100, label: '100' }
  ];

  useEffect(() => {
    const fetchPurchaseOrders = async () => {
      try {
        setLoading(true); // Start loader

        // ✅ Fetch only 'Generated' purchase orders
        const res = await PoServices.AllPOByStatus("Order-Received");
        const poList = res?.data || [];
        setPurchaseOrders(poList);
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "Failed to fetch purchase orders", "error");
      } finally {
        setLoading(false); // Stop loader
      }
    };

    fetchPurchaseOrders();
  }, [test]); // Optional: use dependency if needed



  const filteredSearch = [...purchaseOrders]
    .filter(po => {

      const requisitionNumber =
        String(
          po?.requisitionNo?.requisitionNo || ""
        );

      const poNumber =
        String(
          po?.poNumber || ""
        );

      const supplierName =
        po?.items
          ?.map(item =>
            String(
              item?.supplier?.name || ""
            ).toLowerCase()
          )
          .join(" ") || "";

      const createdBy =
        String(
          po?.createdBy?.name || ""
        ).toLowerCase();

      const storeLocation =
        String(
          po?.requisitionNo?.store?.name || ""
        ).toLowerCase();

      const partNos =
        po?.items
          ?.map(item =>
            String(
              item?.partNo || ""
            ).toLowerCase()
          )
          .join(" ") || "";

      const descriptions =
        po?.items
          ?.map(item =>
            String(
              item?.description || ""
            ).toLowerCase()
          )
          .join(" ") || "";


      // ==========================================
      // REVISION SEARCH
      // ==========================================

      const revisionNo =
        Number(
          po?.commercialRevisionCount || 0
        );

      const isRevised =
        revisionNo > 0;

      const revisionText =
        isRevised
          ? `revised revision ${revisionNo} rev ${revisionNo}`
          : "new original";


      const search =
        searchTerm
          .toLowerCase()
          .trim();


      return (
        requisitionNumber.includes(search) ||
        poNumber.includes(search) ||
        supplierName.includes(search) ||
        createdBy.includes(search) ||
        storeLocation.includes(search) ||
        partNos.includes(search) ||
        descriptions.includes(search) ||
        revisionText.includes(search)
      );
    })

    // ==========================================
    // REVISION SORT
    // ==========================================

    .sort((a, b) => {

      if (!revisionSortOrder) {
        return 0;
      }

      /*
       * New/original PO = 0
       * Revised Rev 1 = 1
       * Revised Rev 2 = 2
       * etc.
       */

      const revisionA =
        Number(
          a?.commercialRevisionCount || 0
        );

      const revisionB =
        Number(
          b?.commercialRevisionCount || 0
        );


      if (revisionSortOrder === "asc") {
        return revisionA - revisionB;
      }

      return revisionB - revisionA;
    });


  const pagination = Math.ceil(filteredSearch.length / sort);
  const handleRevisionSort = () => {

    setRevisionSortOrder(prev => {

      if (prev === "asc") {
        return "desc";
      }

      return "asc";
    });

    setActivePage(0);
  };

  const onClick = (i) => {
    setActivePage(i);
  };

  useEffect(() => {
    setActivePage(0);
  }, [searchTerm, sort]);


  // ==========================================
  // PRINT PO WITH REVISION HISTORY
  // ==========================================

  const handleViewClick = async (poDetails) => {
    const poId = poDetails?._id;

    if (!poId) {
      Swal.fire(
        "Error",
        "Purchase Order ID is missing.",
        "error"
      );
      return;
    }

    if (printLoadingId) return;

    try {
      setPrintLoadingId(String(poId));

      // Clear previous print data
      setSelectedItem(null);

      const response =
        await PoServices.getPurchaseOrderPrintHistory(poId);

      const printData =
        response?.data?.data ||
        response?.data ||
        null;

      const versions =
        Array.isArray(printData?.versions)
          ? printData.versions
          : [];

      if (!printData) {
        Swal.fire(
          "Print Data Missing",
          "Purchase Order print data was not found.",
          "warning"
        );
        return;
      }

      if (!versions.length) {
        Swal.fire(
          "No PO Versions",
          "Original or revised Purchase Order versions were not found.",
          "warning"
        );
        return;
      }

      setSelectedItem(printData);
      setGridInsideModal(true);

    } catch (error) {
      console.error(error);

      Swal.fire(
        "Error",
        error?.response?.data?.message ||
        error?.message ||
        "Unable to load Purchase Order print history.",
        "error"
      );
    } finally {
      setPrintLoadingId("");
    }
  };



  const handleViewItem = (e, row) => {
    e.stopPropagation(); // prevent bubbling if inside clickable row
    setSelectedItem2(row);
    setGridInsideModal2(true);
  };

  const handleBillingView = (e, row) => {
    e.stopPropagation(); // prevent bubbling if inside clickable row
    setSelectedItem3(row);
    setGridInsideModal3(true);
  };

  const exportToExcel = () => {
    if (!filteredSearch || filteredSearch.length === 0) {
      Swal.fire("Info", "No purchase orders to export.", "info");
      return;
    }

    const dataForExcel = filteredSearch.map((row, idx) => {
      return {
        "#": idx + 1,
        "Requisition": row?.requisitionNo?.requisitionNo || row?.requisitionNo?._id || "N/A",
        "PO Number": row?.poNumber || "N/A",
        "Part No": row?.items?.map(item => item?.partNo).join(", ") || "N/A",
        "Description": row?.items?.map(item => item?.description).join(", ") || "N/A",
        "Qty": row?.items?.map(item => item?.approveQty).join(", ") || "N/A",
        "Rate": row?.items?.map(item => item?.rate).join(", ") || "N/A",
        "Store": row?.requisitionNo?.store?.name || "N/A",
        "Supplier": row?.items?.map(item => item?.supplier?.name).join(", ") || "N/A",
        "Delivery Address": `${row?.deliveryAddress?.street}, ${row?.deliveryAddress?.city}, ${row?.deliveryAddress?.state} - ${row?.deliveryAddress?.pincode}, ${row?.deliveryAddress?.country}`,
        "Created At": new Date(row?.createdAt).toLocaleDateString('en-IN'),
        "Items Count": row?.items?.length || 0
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "PurchaseOrders");

    XLSX.writeFile(workbook, "PurchaseOrders.xlsx");
  };



  return (
    loading ? (
      <Loader />
    ) : (
      <>
        {selectedItem2 && (
          <ReceivedOrderModal
            show={gridInsideModal2}
            handleClose={() => setGridInsideModal2(false)}
            test={setTest}
            admin={selectedItem2}
          />
        )}

        {selectedItem3 && (
          <BillingViewModal
            show={gridInsideModal3}
            handleClose={() => setGridInsideModal3(false)}
            test={setTest}
            admin={selectedItem3}
          />
        )}

        {selectedItem && (
          <PoRevisionPrintModal
            show={gridInsideModal}
            onHide={() => {
              setGridInsideModal(false);
              setSelectedItem(null);
            }}
            printHistory={selectedItem}
          />
        )}
        <div className="row">
          <div className="col-xl-12">

            {/* Filter */}
            <div className="filter cm-content-box box-primary">
              <div className="content-title">
                <div className="cpa"><i className="fas fa-filter me-2"></i>Filter</div>
                <div className="tools">
                  <Link to="#" className={`SlideToolHeader ${open ? 'collapse' : 'expand'}`} onClick={() => setOpen(!open)}>
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>
              <Collapse in={open}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-3 col-xxl-6 mb-3">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search by PO, Requisition, Part No, Supplier, Store, New or Revised"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </div>
                      <div className="col-xl-3 col-xxl-6 mb-3">
                        <Select
                          placeholder="Rows per page"
                          value={options.find(option => option.value === sort)}
                          onChange={(selectedOption) => setSort(Number(selectedOption.value))}
                          isSearchable={false}
                          options={options}
                          className="custom-react-select"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>

            {/* Table */}
            <div className="filter cm-content-box box-primary">
              <div className="content-title">
                <div className="cpa">
                  <i className="fa fa-list me-2"></i>All Orders Received Against PO
                  <span className="badge bg-orange ms-2">{filteredSearch.length}</span>
                </div>


                {/* Right side: Download + Collapse Tools */}
                <div className="d-flex align-items-center gap-2">


                  <div className="tools">
                    <Link
                      to="#"
                      className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                      onClick={() => setOpen2(!open2)}
                    >
                      <i className="fas fa-angle-up"></i>
                    </Link>
                  </div>
                </div>
              </div>

              <Collapse in={open2}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="d-flex justify-content-end  mb-3">
                      <button
                        className="btn btn-success btn-sm"
                        onClick={exportToExcel}
                      >
                        <i className="fa fa-file-excel me-1"></i>
                        Download Excel
                      </button>
                    </div>
                    <div className="table-responsive">
                      <div id="content_wrapper" className="dataTables_wrapper no-footer">
                        <div style={{
                          overflowX: 'auto',
                          overflowY: 'auto',
                          maxHeight: '400px',
                          whiteSpace: 'nowrap'
                        }}>
                          <table className="table table-bordered table-responsive-lg table-striped table-condensed flip-content" id="active-users-data">
                            <thead
                              style={{
                                position: "sticky",
                                top: 0,
                                backgroundColor: "#fff", // White background
                                zIndex: 2,
                              }}
                            >
                              <tr>
                                <th>#</th>
                                <th>Requisition</th>
                                <th>Po</th>
                                <th
                                  onClick={handleRevisionSort}
                                  style={{
                                    cursor: "pointer",
                                    whiteSpace: "nowrap"
                                  }}
                                >
                                  Revision{" "}

                                  {revisionSortOrder === "asc"
                                    ? "🔼"
                                    : revisionSortOrder === "desc"
                                      ? "🔽"
                                      : "⇅"}
                                </th>                                <th>Part No</th>
                                <th>Description</th>
                                <th>Qty</th>
                                <th>Rate</th>
                                <th>Store</th>
                                <th>Suppplier</th>
                                <th>Deliver Address</th>
                                <th>CreatedAt</th>
                                <th>Items</th>
                                <th>View Items</th>
                                <th>Print</th>
                              </tr>
                            </thead>
                            <tbody>
                              {filteredSearch.length > 0 ? (
                                filteredSearch
                                  .slice(activePage * sort, (activePage + 1) * sort)
                                  .map((row, index) => (
                                    <tr key={index}>
                                      <td>{activePage * sort + index + 1}</td>
                                      <td>{row?.requisitionNo?.requisitionNo || row?.requisitionNo?._id || 'N/A'}</td>
                                      <td>{row?.poNumber || 'N/A'}</td>
                                      <td>
                                        {Number(row?.commercialRevisionCount || 0) > 0 ? (
                                          <span className="badge bg-warning text-dark">
                                            Rev {row?.commercialRevisionCount}
                                          </span>
                                        ) : (
                                          <span className="badge bg-success">
                                            New
                                          </span>
                                        )}
                                      </td>
                                      <td>
                                        {row?.items?.map((item, idx) => (
                                          <div key={idx}>{item?.partNo || 'N/A'}</div>
                                        ))}
                                      </td>
                                      <td className="scrollable-description">
                                        {row?.items?.map((item, idx) => (
                                          <div key={idx}>{item?.description || 'N/A'}</div>
                                        ))}
                                      </td>
                                      <td>
                                        {row?.items?.map((item, idx) => (
                                          <div key={idx}>{item?.approveQty || 'N/A'}</div>
                                        ))}
                                      </td>
                                      <td>
                                        {row?.items?.map((item, idx) => (
                                          <div key={idx}>{item?.rate || 'N/A'}</div>
                                        ))}
                                      </td>
                                      <td className="scrollable-description">{row?.requisitionNo?.store?.name}</td>
                                      <td className="scrollable-description">
                                        {row?.items?.map((item, idx) => (
                                          <div key={idx}>{item?.supplier?.name || 'N/A'}</div>
                                        ))}
                                      </td>
                                      <td className="scrollable-description">
                                        {row?.deliveryAddress?.street}, {row?.deliveryAddress?.city},<br />
                                        {row?.deliveryAddress?.state} - {row?.deliveryAddress?.pincode},<br />
                                        {row?.deliveryAddress?.country}
                                      </td>
                                      <td>{new Date(row?.createdAt).toLocaleDateString('en-IN')}</td>
                                      <td>{row?.items?.length || 0}</td>
                                      <td><i className="fa fa-eye" onClick={(e) => { handleViewItem(e, row) }}></i>
                                      </td>
                                      <td>
                                        <button
                                          type="button"
                                          className="btn btn-success btn-xs"
                                          disabled={Boolean(printLoadingId)}
                                          onClick={() => handleViewClick(row)}
                                        >
                                          {String(printLoadingId) === String(row?._id) ? (
                                            <>
                                              <span
                                                className="spinner-border spinner-border-sm me-1"
                                                role="status"
                                                aria-hidden="true"
                                              />
                                              Loading...
                                            </>
                                          ) : (
                                            <>
                                              <i className="fa fa-print me-1" />
                                              Print
                                              <span
                                                className="badge bg-light text-dark ms-2"
                                                style={{
                                                  minWidth: "24px",
                                                  fontSize: "11px",
                                                }}
                                              >
                                                {row?.printCount || 1}
                                              </span>
                                            </>
                                          )}
                                        </button>
                                      </td>


                                    </tr>
                                  ))
                              ) : (
                                <tr><td colSpan="15" className="text-center">No Purchase Orders Found</td></tr>
                              )}
                            </tbody>
                          </table>
                        </div>

                        {/* Pagination */}
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <div className="dataTables_info">
                            Showing {filteredSearch.length > 0 ? activePage * sort + 1 : 0} to{" "}
                            {Math.min(filteredSearch.length, (activePage + 1) * sort)}  of {filteredSearch.length} entries
                          </div>
                          <Pagination
                            activePage={activePage}
                            totalPages={pagination}
                            onPageChange={onClick}
                          />
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        </div>
      </>
    )
  );
};

export default RecivedOrderPO;
